import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"


export interface IDetalheCidade {

    codigo: number;
    nome: string;
    capital: number;
    codEstado: number;

}

export interface IListagemCidade {
    codigo: number;
    nome: string;
    capital: boolean;
    codEstado: string;

}

export interface IDadosRetornoCidade {
    dado: IListagemCidade[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoEdicao {
    dado: IDetalheCidade;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

interface RespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros: string;
    mensagem: string;
    dado: number;
}

export interface IDadosRetorno {
    dado: IDadosRetornoCidade;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosRetornoCidEst {
    dado: IDetalheCidade[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

type TCidadesComTotalCount = {
    data: IDadosRetornoCidade;
    totalCount: number;
}


type TCidadesComTotal = {
    data: IDadosRetornoCidEst;
}


const getAll = async (page = 1, filter = '', id = 0, codigoEstado = 0): Promise<TCidadesComTotalCount> => {
    filter = codigoEstado > 0 ? `codEstado = ${codigoEstado}` : "1=1";
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/cidade/sql`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            NumeroPagina: page,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: filter
        }
    });  
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getById = async (codigo: number): Promise<IDadosRetornoEdicao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEdicao>(`/cidade/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;

}

const Create = async (dados: Omit<IDetalheCidade, "codigo">): Promise<number> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post<RespostaCreate>(`/cidade`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data.dado;


}

const updateById = async (dados: IDetalheCidade): Promise<void> => {
  
        const token = CookieService.get("access_token");
        await Api.put<IDetalheCidade>(`/cidade`, dados, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
   

}

const deleteById = async (codigo: number): Promise<void> => {
   
        const token = CookieService.get("access_token");
        const user = CookieService.get("access_user"); // localStorage.getItem("@Auth:user");
        await Api.delete(`/cidade/${codigo}/${user.codUsuario}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
    
}

const getByIdEstado = async (codigo: number): Promise<IDadosRetornoCidEst> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/cidade/estado/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });   
        return data;
   
}



export const CidadeService = {

    getAll,
    getById,
    Create,
    updateById,
    deleteById,
    getByIdEstado
}